export const warn = (message: string) => {
  console.warn('[react-carrotquest]', message);
};
